import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-switcher',
  template: `
    <div class="lang-switcher-wrapper">
      <i class="fa fa-globe lang-icon" aria-hidden="true"></i>
      <select
        class="lang-switcher"
        [ngModel]="currentLang"
        (ngModelChange)="switchLanguage($event)"
      >
        <option *ngFor="let lang of languages" [value]="lang.code">
          {{ lang.label }}
        </option>
      </select>
    </div>
  `,
  styles: [`
    .lang-switcher-wrapper {
      position: relative;
      display: inline-flex;
      align-items: center;
    }
    .lang-icon {
      position: absolute;
      left: 10px;
      color: #FFF;
      font-size: 14px;
      pointer-events: none;
      z-index: 1;
    }
    .lang-switcher {
      appearance: none;
      -webkit-appearance: none;
      padding: 6px 28px 6px 30px;
      border: 1.5px solid rgba(255, 255, 255, 0.6);
      border-radius: 10px;
      background-color: rgba(255, 255, 255, 0.15);
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='white' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 10px center;
      font-size: 13px;
      font-weight: 600;
      font-family: "Roboto", "Noto Sans TC", sans-serif;
      cursor: pointer;
      outline: none;
      color: #FFF;
      transition: all 200ms ease;
    }
    .lang-switcher:hover {
      background-color: rgba(255, 255, 255, 0.25);
      border-color: rgba(255, 255, 255, 0.8);
    }
    .lang-switcher:focus {
      background-color: rgba(255, 255, 255, 0.3);
      border-color: #FFF;
      box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
    }
    .lang-switcher option {
      background-color: #FFF;
      color: #333;
      font-weight: 500;
    }
  `]
})
export class LanguageSwitcherComponent {
  currentLang: string;

  languages = [
    { code: 'zh-TW', label: '繁體中文' },
    { code: 'en', label: 'English' }
  ];

  constructor(private translate: TranslateService) {
    this.currentLang = this.translate.currentLang || this.translate.defaultLang || 'zh-TW';
  }

  switchLanguage(lang: string): void {
    this.currentLang = lang;
    this.translate.use(lang);
    localStorage.setItem('app_lang', lang);
  }
}

